module.exports = __webpack_public_path__ + "static/media/cart.0752895e.svg";